import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import subscriptionService from "services/subscription";

export const getSubscriptionsAsync = createAsyncThunk(
  "subscriptions/getSubscriptionsAsync",
  async (queryParams) => {
    const res = await subscriptionService.getAll(queryParams);
    return res.data;
  }
);

export const getSubscriptionByIdAsync = createAsyncThunk(
  "subscriptions/getSubscriptionsAsync",
  async ({ subscriptionId }) => {
    const res = await subscriptionService.getOne(subscriptionId);
    return res.data;
  }
);

export const addSubscriptionAsync = createAsyncThunk(
  "subscriptions/addSubscriptionAsync",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await subscriptionService.create(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editSubscriptionAsync = createAsyncThunk(
  "subscriptions/editSubscriptionAsync",
  async ({ subscriptionId, data }) => {
    const res = await subscriptionService.update(subscriptionId, data);
    return res.data;
  }
);

export const deleteSubscriptionAsync = createAsyncThunk(
  "subscriptions/deleteSubscriptionAsync",
  async ({ subscriptionId }, { rejectWithValue }) => {
    try {
      await subscriptionService.remove(subscriptionId);
      return { subscriptionId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addFeatureAsync = createAsyncThunk(
  "subscriptions/addFeatureAsync",
  async ({ subscriptionId, data }) => {
    const res = await subscriptionService.addFeature(subscriptionId, data);
    return res.data;
  }
);

export const updateFeatureAsync = createAsyncThunk(
  "subscriptions/updateFeatureAsync",
  async ({ subscriptionId, featureId, data }) => {
    const res = await subscriptionService.updateFeature(
      subscriptionId,
      featureId,
      data
    );
    return res.data;
  }
);

export const deleteFeatureAsync = createAsyncThunk(
  "subscriptions/deleteFeatureAsync",
  async ({ subscriptionId, featureId }) => {
    const res = await subscriptionService.deleteFeature(
      subscriptionId,
      featureId
    );
    return res.data;
  }
);

export const addCurrencyAsync = createAsyncThunk(
  "subscriptions/addCurrencyAsync",
  async ({ subscriptionId, data }) => {
    const res = await subscriptionService.addCurrency(subscriptionId, data);
    return res.data;
  }
);

export const updateCurrencyAsync = createAsyncThunk(
  "subscriptions/updateCurrencyAsync",
  async ({ subscriptionId, currencyId, data }) => {
    const res = await subscriptionService.updateCurrency(
      subscriptionId,
      currencyId,
      data
    );
    return res.data;
  }
);

export const deleteCurrencyAsync = createAsyncThunk(
  "subscriptions/deleteCurrencyAsync",
  async ({ subscriptionId, currencyId }) => {
    const res = await subscriptionService.deleteCurrency(
      subscriptionId,
      currencyId
    );
    return res.data;
  }
);

const initialState = {
  subscriptions: {
    items: [],
    totalCount: 0,
  },
  selectedSubscription: {},
  mode: "",
  addSubscription: {
    status: "idle",
    error: false,
  },
  getSubscriptions: {
    status: "idle",
    error: false,
  },
  updatingSubscription: {
    status: "idle",
    error: false,
  },
  updatingFeatures: [],
  deletingFeatures: [],
};

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    updateSubscriptionState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetSubscriptionsSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(editSubscriptionAsync.pending, (state) => {
        state.updatingSubscription.status = "loading";
        state.updatingSubscription.error = false;
      })
      .addCase(editSubscriptionAsync.fulfilled, (state, action) => {
        state.updatingSubscription.status = "loading";
        state.updatingSubscription.error = false;
      })
      .addCase(editSubscriptionAsync.rejected, (state, action) => {
        state.updatingSubscription.status = "failed";
        state.updatingSubscription.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      })
      .addCase(getSubscriptionsAsync.pending, (state) => {
        state.getSubscriptions.status = "loading";
        state.getSubscriptions.error = false;
      })
      .addCase(getSubscriptionsAsync.fulfilled, (state, action) => {
        state.getSubscriptions.status = "idle";
        state.subscriptions = action.payload;
      })
      .addCase(getSubscriptionsAsync.rejected, (state, action) => {
        state.getSubscriptions.status = "failed";
        state.getSubscriptions.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      });
  },
});

export const { updateSubscriptionState, resetSubscriptionsSlice } =
  subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
